import * as React from 'react';
import moment from 'moment';
import isEqual from 'react-fast-compare';
import { connect } from 'react-redux';
import DateTime from 'react-datetime';
import notify from '../../shared/feedback/notifications';
import { Button, Col, ControlLabel, FormGroup, Panel, Row, Tab, Tabs } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import { assign } from '../../shared/Assign';
import Calendar from '../calendar/Calendar';
import { formatTimeTwoDigitAs, toMinMaxTime } from '../calendar/calendarTimeUtils';
import FormSelect from '../../components/common/FormSelect';
import IRegion from '../regions/types/region';
import ICalendar from '../calendar/ICalendar';
import IWorkingHour from '../calendar/IWorkingHour';
import ICalendarItem, { ICalendarItemType } from '../calendar/Types';
import PhotographerCalendarComponent from '../photographerPersonalCalendar/PhotographerCalendarComponent';
import WorkingHoursForm from '../photographerPersonalCalendar/WorkingHoursForm';
import RadioInputSwitch from '../../components/common/RadioInputSwitch';
import * as Site from '../../shared/Site';
import * as Actions from './actions/CalendarActions';
import { IPhotographerDto } from './types/types';
import SmsModal from './SmsModal';
import EmailModal from './EmailModal';
import { limitEventEndToStartDay } from '../calendar/calendarEventUtils';
import MailIcon from '@mui/icons-material/Mail';
import SmsIcon from '@mui/icons-material/Sms';
import Tooltip from '@mui/material/Tooltip';
import {getSiteName} from "../../shared/Site";
import SendEmailToPhotographersModal from '../photographers/SendEmailToPhotographersModal';
import Loader from 'react-loader';

interface IActions {
    getPhotographersByRegion: () => any;
    getMultiplePhotographerCalendars: (ids: number[], from: any, to: any) => ICalendar[];
    createPhotographerCalendarItem: (item: any) => Promise<any>;
    deletePhotographerCalendarItem: (item: any) => Promise<any>;
    updatePhotographerCalendarItem: (item: any) => Promise<any>;
    updatePhotographerCalendarWorkingHours: (
        photographerId: number,
        se360WorkingHours: any[],
        scandphotosWorkingHours: any[]
    ) => Promise<any>;
}

interface IProps {
    regions: IRegion[];
    photographers: IPhotographerDto[];
    photographersByRegion: number[][];
    calendars: ICalendar[];
    user: any;
    site: string;
    actions: IActions;
}

class PhotographerCalendarPage extends React.Component<IProps, any> {
    constructor(props: IProps, context: any) {
        super(props, context);
        this.onDateChange = this.onDateChange.bind(this);

        let calendarSettings: any = {};

        this.state = {
            calendars: [],
            calendarSettings: calendarSettings,
            selectedPhotographer: -1,
            selectedRegion: -1,
            selectedDate: moment(),
            selectedPhotographersSe360WorkingHours: null,
            selectedPhotographersScandphotosWorkingHours: null,
            selectedWorkingHoursSite: 1,
            photographers: [],
            from: moment(),
            to: moment(),
            lastFetch: {},
            showSe360WorkingHours: true,
            showSendEmailToPhotographersModal: false,
            photographersInRegion: [],
        };

        this.onCreated = this.onCreated.bind(this);
        this.onDeleted = this.onDeleted.bind(this);
        this.onUpdated = this.onUpdated.bind(this);
        this.onWorkingHoursChanged = this.onWorkingHoursChanged.bind(this);
        this.saveWorkingHours = this.saveWorkingHours.bind(this);
        this.getCalendars = this.getCalendars.bind(this);
        this.selectPhotographer = this.selectPhotographer.bind(this);
        this.openSendEmailToPhotographersModal = this.openSendEmailToPhotographersModal.bind(this);
        this.closeSendEmailToPhotographersModal = this.closeSendEmailToPhotographersModal.bind(this);
    }

    componentDidMount() {
        this.props.actions.getPhotographersByRegion();
    }

    openSendEmailToPhotographersModal(regionId: number) {
        const photographersInRegion = this.props.photographers.filter(
            (p) => p.regionId === regionId
        );
        this.setState({
            showSendEmailToPhotographersModal: true,
            photographersInRegion: photographersInRegion,
        });
    }

    closeSendEmailToPhotographersModal() {
        this.setState({
            showSendEmailToPhotographersModal: false,
            photographersInRegion: [],
        });
    }

    updateCalendars = (previousCalendars, previousSelectedDate, previousSelectedPhotographer) => {
        let { calendars } = this.props;
        let { selectedDate, selectedPhotographer } = this.state;

        let hasCalendarsChanged =
            !isEqual(previousCalendars, calendars) ||
            previousSelectedDate !== selectedDate ||
            previousSelectedPhotographer !== selectedPhotographer;

        if (hasCalendarsChanged) {
            let _calendars = this.createCalendars(assign([], calendars));

            this.setState({
                loading: false,
                calendars: _calendars
            });
        }
    };

    updateWorkHours = (previousCalendars, previousSelectedDate, previousSelectedPhotographer) => {
        let { calendars } = this.props;
        let { selectedDate, selectedPhotographer } = this.state;

        if (
            previousSelectedDate !== selectedDate ||
            previousSelectedPhotographer !== selectedPhotographer ||
            !isEqual(previousCalendars, calendars)
        ) {
            this.setState({
                selectedPhotographersSe360WorkingHours:
                    calendars && calendars.length > 0 ? calendars[0].se360WorkingHours : null,
                selectedPhotographersScandphotosWorkingHours:
                    calendars && calendars.length > 0 ? calendars[0].scandphotosWorkingHours : null
            });
        }
    };

    componentDidUpdate(previousProps, previousState) {
        this.updateCalendars(
            previousProps.calendars,
            previousState.selectedDate,
            previousState.selectedPhotographer
        );
        this.updateWorkHours(
            previousProps.calendars,
            previousState.selectedDate,
            previousState.selectedPhotographer
        );
    }

    getDefaultCalendarSettings() {
        let calendarSettings: any = {
            selectable: false,
            eventRender: (event, element) => {
                element.append(
                    `<div style="font-size:10px;font-weight: bold;">` +
                        `<span style="font-size:11px">${event.description}</span>` +
                        `</br>` +
                        `<span>${event.originalTitle ? event.originalTitle : ''}</span>` +
                        `<span>${
                            !event.originalTitle && event.product ? event.product : ''
                        }</span>` +
                        `</div>`
                );
            },
            slotLabelFormat: 'HH:mm',
            timeFormat: 'HH:mm',
            minTime: '07:00:00',
            maxTime: '18:00:00',
            firstDay: 0,
            defaultView: 'photographerView',
            highlightToday: false,
            disableResizing: true,
            views: {
                photographerView: {
                    type: 'agenda',
                    duration: { days: 7 }
                }
            },
            header: {
                left: '',
                center: '',
                right: ''
            }
        };

        return calendarSettings;
    }

    createCalendars(calendars: any, date?: any) {
        let currentDate = date || this.state.selectedDate;
        let filteredCalendars = calendars;
        if (this.state.selectedRegion > 0) {
            filteredCalendars = calendars.filter((calendar) => {
                if (this.state.showSe360WorkingHours) {
                    let matchingDay = calendar.se360WorkingHours.find((item: IWorkingHour) => {
                        return item.day === currentDate.day();
                    });
                    return matchingDay && matchingDay.isAvailable;
                } else {
                    let matchingDay = calendar.scandphotosWorkingHours.find(
                        (item: IWorkingHour) => {
                            return item.day === currentDate.day();
                        }
                    );
                    return matchingDay && matchingDay.isAvailable;
                }
            });
        }
        return this.sliceCalendars(filteredCalendars, currentDate || null);
    }

    sliceCalendars(photographerCalendars: any, date?: any) {
        let sliced = [];
        let calendarList = [];

        for (let i = 0; i < photographerCalendars.length; i++) {
            if (i > 0 && i % 5 === 0) {
                calendarList.push(this.createCalendar(sliced, date || null));
                sliced = [];
            }
            sliced.push(photographerCalendars[i]);
        }
        if (sliced.length > 0) {
            calendarList.push(this.createCalendar(sliced, date || null));
        }
        return calendarList;
    }

    createCalendar(photographerCalendars: any, selectedDate?: any) {
        if (photographerCalendars.length === 0) {
            this.setState({
                loading: false
            });
            return;
        }
        let settings = this.getDefaultCalendarSettings();

        const { apiUrl } = window.appConfig;

        // Set amount of 'days' corresponding to nr of photographerCalendars
        settings.views.photographerView.duration = {
            days: photographerCalendars.length
        };
        let currentDate = selectedDate || this.state.selectedDate;
        settings.defaultDate =
            currentDate.day() === 0
                ? currentDate.format()
                : moment(currentDate.format()).isoWeekday(0).format();

        settings.workingHours = [];
        let events = [];
        let names = [];

        // Due to fullcalender does not work with locale, has not included locale files
        moment.locale('en');
        let minTime = 7;
        let maxTime = 18;
        photographerCalendars.forEach((calendar: any, index: number) => {
            let photographerQuery = this.props.photographers.filter((p) => {
                return p.id === calendar.photographerId;
            });
            let photographer =
                photographerQuery.length === 1
                    ? photographerQuery[0]
                    : { name: '', id: -1, profileImageReference: null };

            let se360WorkingHours = calendar.se360WorkingHours.filter((item: IWorkingHour) => {
                return item.day === currentDate.day();
            });

            let scandphotosWorkingHours = calendar.scandphotosWorkingHours.filter(
                (item: IWorkingHour) => {
                    return item.day === currentDate.day();
                }
            );

            const currentWorkingHours = this.state.showSe360WorkingHours
                ? se360WorkingHours
                : scandphotosWorkingHours;
            currentWorkingHours.forEach((item: IWorkingHour) => {
                // +/- 1 to get a margin
                const itemStartHour = moment(item.start).hours() - 1;
                const itemEndHour = moment(item.end).hours() + 1;

                minTime = itemStartHour < minTime ? itemStartHour : minTime;
                maxTime = itemEndHour > maxTime ? itemEndHour : maxTime;
            });

            calendar.items
                .filter((item: ICalendarItem) => {
                    return moment(item.start).startOf('day').isSame(currentDate.startOf('day'));
                })
                .forEach((item: ICalendarItem) => {
                    let event = assign({}, item);

                    event.start = moment.parseZone(item.start as any);
                    event.end = moment.parseZone(item.end as any);

                    event.originalStart = event.start.format();
                    event.originalEnd = event.end.format();

                    event.end = limitEventEndToStartDay(event.start, event.end);

                    event.start =
                        event.start.weekday() === index
                            ? event.start.format()
                            : event.start.weekday(index).format();
                    event.end =
                        event.end.weekday() === index
                            ? event.end.format()
                            : event.end.weekday(index).format();

                    // +/- 1 to get a margin
                    const eventStartHour = moment(event.start).hours() - 1;
                    const eventEndHour = moment(event.end).hours() + 1;

                    minTime = eventStartHour < minTime ? eventStartHour : minTime;
                    maxTime = eventEndHour > maxTime ? eventEndHour : maxTime;

                    if (item.site) {
                        event.className = [Site.getOrderCssClass(item.site)];
                    }
                    events.push(event);
                });

            let name = `<div class="photographer-header" data-photographer-id="${photographer.id}">`;

            if (
                se360WorkingHours.length > 0 &&
                se360WorkingHours[0].isAvailable === true &&
                this.state.showSe360WorkingHours
            ) {
                let w = assign({}, se360WorkingHours[0]);
                w.day = index;
                settings.workingHours.push(w);
            }

            if (
                scandphotosWorkingHours.length > 0 &&
                scandphotosWorkingHours[0].isAvailable === true &&
                !this.state.showSe360WorkingHours
            ) {
                let w = assign({}, scandphotosWorkingHours[0]);
                w.day = index;
                settings.workingHours.push(w);
            }

            let profileImageUrl = photographer.profileImageReference
                ? `${apiUrl}/file/${photographer.profileImageReference}`
                : 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAyNTAgMjUwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI2Ni40MyAtNDAxLjY1KSI+CiAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoLjY4MzMzIDAgMCAuNjgzMzMgNTgxLjk0IDU1MC43NykiIGZpbGw9IiNEREREREQiPgogICA8cmVjdCB4PSItNDYxLjczIiB5PSItMjE4LjIzIiB3aWR0aD0iMzY1Ljg1IiBoZWlnaHQ9IjM2NS44NSIgcng9IjAiIHJ5PSIwIiBjb2xvcj0iIzAwMDAwMCIgZmlsbD0iI0RERERERCIvPgogIDwvZz4KICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCguMzQ5MiAwIDAgLjM0OTIgMjg0LjU3IDQxOS43OSkiIGZpbGw9IiNGRkYiPgogICA8ZyBmaWxsPSIjRkZGIj4KICAgIDxwYXRoIGQ9Im0zMDYgMzI1Ljk5YzkwLjU2LTAuMDEgMTIzLjE1LTkwLjY4IDEzMS42OC0xNjUuMTcgMTAuNTEtOTEuNzYtMzIuODgtMTYwLjgyLTEzMS42OC0xNjAuODItOTguNzggMC0xNDIuMTkgNjkuMDU1LTEzMS42OCAxNjAuODIgOC41NCA3NC40ODQgNDEuMTE0IDE2NS4xOCAxMzEuNjggMTY1LjE3eiIvPgogICAgPHBhdGggZD0ibTU1MC45OCA1NDEuOTFjLTAuOTktMjguOTA0LTQuMzc3LTU3LjkzOS05LjQyMS04Ni4zOTMtNi4xMTEtMzQuNDY5LTEzLjg4OS04NS4wMDItNDMuOTgzLTEwNy40Ni0xNy40MDQtMTIuOTg4LTM5Ljk0MS0xNy4yNDktNTkuODY1LTI1LjA4MS05LjY5Ny0zLjgxLTE4LjM4NC03LjU5NC0yNi41MzctMTEuOTAxLTI3LjUxOCAzMC4xNzYtNjMuNCA0NS45NjItMTA1LjE5IDQ1Ljk2NC00MS43NzQgMC03Ny42NTItMTUuNzg2LTEwNS4xNy00NS45NjQtOC4xNTMgNC4zMDgtMTYuODQgOC4wOTMtMjYuNTM3IDExLjkwMS0xOS45MjQgNy44MzItNDIuNDYxIDEyLjA5Mi01OS44NjMgMjUuMDgxLTMwLjA5NiAyMi40NjMtMzcuODczIDcyLjk5Ni00My45ODMgMTA3LjQ2LTUuMDQ1IDI4LjQ1NC04LjQzMyA1Ny40ODktOS40MjIgODYuMzkzLTAuNzY2IDIyLjM4NyAxMC4yODggMjUuNTI1IDI5LjAxNyAzMi4yODQgMjMuNDUzIDguNDU4IDQ3LjY2NiAxNC43MzcgNzIuMDQxIDE5Ljg4NCA0Ny4wNzcgOS45NDEgOTUuNjAzIDE3LjU4MiAxNDMuOTIgMTcuOTI0IDQ4LjMxOC0wLjM0MyA5Ni44NDQtNy45ODMgMTQzLjkyLTE3LjkyNCAyNC4zNzUtNS4xNDUgNDguNTktMTEuNDI0IDcyLjA0MS0xOS44ODQgMTguNzM2LTYuNzU3IDI5Ljc4OS05Ljg5NSAyOS4wMjMtMzIuMjg0eiIvPgogICA8L2c+CiAgPC9nPgogPC9nPgo8L3N2Zz4K';

            name += `<div class="photographer-image" style="background-image: url('${profileImageUrl}')"></div>
                     <div class="photographer-info">
                         <div class="photographer-name clickable">${photographer.name}</div>
                         <div class="photographer-communication">
                            <i class="material-icons md-18 email-icon">email</i>
                            <i class="material-icons md-18 sms-icon">sms</i>
                            <i class="material-icons md-18 directions-car-icon hide clickable">directions_car</i>
                        </div>
                     </div>`;
            names.push(name);
        });

        const minMaxTime = toMinMaxTime(minTime, maxTime);
        settings.minTime = minMaxTime.minTime;
        settings.maxTime = minMaxTime.maxTime;

        // Due to fullcalender does not work with locale, has not included locale files
        moment.locale(this.props.user.details.languageKey);

        events = events.filter((e) => {
            return e.start !== null && e.end !== null;
        });
        settings.eventSources = [
            {
                events: events
            }
        ];

        settings.dayNames = names;

        return settings;
    }

    getWorkingHoursAsString(workingHour: IWorkingHour) {
        const startHours = moment(workingHour.start).hours();
        const startMinutes = moment(workingHour.start).minutes();
        const endHour = moment(workingHour.end).hours();
        const endMinutes = moment(workingHour.end).minutes();

        let start = formatTimeTwoDigitAs(startHours) + ':' + formatTimeTwoDigitAs(startMinutes);
        let end = formatTimeTwoDigitAs(endHour) + ':' + formatTimeTwoDigitAs(endMinutes);

        return start + ' - ' + end;
    }

    onDateChange(value: any) {
        let selectedDate = this.state.selectedDate;
        if (!value.isSame(selectedDate)) {
            this.setState(
                {
                    selectedDate: value,
                    calendars: [],
                    loading: true
                },
                this.getCalendars
            );
        }
    }

    regionChange(value: any) {
        let val = value.target.value;
        this.setState({
            calendars: [],
            loading: true,
            selectedRegion: val,
            selectedPhotographer: -1
        });

        let photographersInRegion = [];
        for (let region in this.props.photographersByRegion) {
            if (region === val.toString()) {
                photographersInRegion = this.props.photographersByRegion[region];
                break;
            }
        }
        if (photographersInRegion.length > 0) {
            this.setState(
                {
                    photographers: photographersInRegion
                },
                this.getCalendars
            );
        } else {
            this.setState({
                loading: false
            });
        }
    }

    photographerChange(value: any) {
        let val = value.target.value;
        this.setState(
            {
                calendars: [],
                loading: true,
                selectedRegion: -1,
                selectedPhotographer: val,
                photographers: [val]
            },
            this.getCalendars
        );
    }

    getCalendars() {
        if (
            this.state.selectedPhotographer > 0 &&
            this.state.photographers &&
            this.state.from &&
            this.state.to &&
            (JSON.stringify(this.state.lastFetch.photographers) !==
                JSON.stringify(this.state.photographers) ||
                this.state.lastFetch.from !== this.state.from ||
                this.state.lastFetch.to !== this.state.to)
        ) {
            this.setState({
                lastFetch: {
                    photographers: this.state.photographers,
                    selectedDate: null,
                    from: this.state.from,
                    to: this.state.to
                }
            });
            return this.props.actions.getMultiplePhotographerCalendars(
                this.state.photographers,
                this.state.from,
                this.state.to
            );
        } else if (
            this.state.photographers &&
            this.state.selectedDate &&
            (JSON.stringify(this.state.lastFetch.photographers) !==
                JSON.stringify(this.state.photographers) ||
                this.state.lastFetch.selectedDate !== this.state.selectedDate)
        ) {
            this.setState({
                lastFetch: {
                    photographers: this.state.photographers,
                    selectedDate: this.state.selectedDate,
                    from: null,
                    to: null
                }
            });
            return this.props.actions.getMultiplePhotographerCalendars(
                this.state.photographers,
                this.state.selectedDate,
                this.state.selectedDate
            );
        }
    }

    onDeleted(event: any) {
        if (this.state.selectedPhotographer && this.state.selectedPhotographer > 0) {
            event.photographerId = this.state.selectedPhotographer;
        }
        this.props.actions.deletePhotographerCalendarItem(event).then(() => {
            notify.success(Translate('calendars/photographer-items/update/toastr/success'));
        });
    }

    onUpdated(event: any) {
        if (this.state.selectedPhotographer && this.state.selectedPhotographer > 0) {
            event.photographerId = this.state.selectedPhotographer;
        }

        this.props.actions.updatePhotographerCalendarItem(event).then(() => {
            notify.success(Translate('calendars/photographer-items/update/toastr/success'));
        });
    }

    onCreated(event: any) {
        event.photographerId = this.state.selectedPhotographer;
        this.props.actions.createPhotographerCalendarItem(event).then(() => {
            notify.success(Translate('calendars/photographer-items/update/toastr/success'));
        });
    }

    onWorkingHoursChanged(workingHours: any[], isSe360WorkingHours: boolean) {
        if (isSe360WorkingHours) {
            this.setState({
                selectedPhotographersSe360WorkingHours: workingHours
            });
        } else {
            this.setState({
                selectedPhotographersScandphotosWorkingHours: workingHours
            });
        }
    }

    saveWorkingHours() {
        let se360WorkingHours = [];
        let scandphotosWorkingHours = [];
        this.state.selectedPhotographersSe360WorkingHours.forEach((x) => {
            se360WorkingHours.push({
                id: x.id,
                isAvailable: x.isAvailable,
                isAvailableForDusk: x.isAvailableForDusk,
                day: x.day,
                start: moment(moment(x.start).toDate()).format('HH:mm:ss'),
                end: moment(moment(x.end).toDate()).format('HH:mm:ss')
            });
        });

        this.state.selectedPhotographersScandphotosWorkingHours.forEach((x) => {
            scandphotosWorkingHours.push({
                id: x.id,
                isAvailable: x.isAvailable,
                isAvailableForDusk: x.isAvailableForDusk,
                day: x.day,
                start: moment(moment(x.start).toDate()).format('HH:mm:ss'),
                end: moment(moment(x.end).toDate()).format('HH:mm:ss')
            });
        });

        this.props.actions
            .updatePhotographerCalendarWorkingHours(
                this.state.selectedPhotographer,
                se360WorkingHours,
                scandphotosWorkingHours
            )
            .then(() => {
                notify.success(
                    Translate('calendars/photographer-working-hours/update/toastr/success')
                );
            });
    }

    openPhotographerSmsModal = (photographerName: string) => {
        const photographer = this.props.photographers.find((x) => x.name === photographerName);
        this.setState({
            showSmsModal: true,
            smsRecipient: {
                photographerId: photographer.id,
                name: photographer.name,
                phoneNumber: photographer.phoneNumber
            }
        });
    };

    openPhotographerEmailModal = (photographerName: string) => {
        const photographer = this.props.photographers.find((x) => x.name === photographerName);
        this.setState({
            showEmailModal: true,
            emailRecipient: {
                photographerId: photographer.id,
                name: photographer.name,
                email: photographer.email
            }
        });
    };

    showDirections = async (photographerId: number) => {
        const photographerAddress = () => {
            const address = () => {
                for (const calendar of this.state.calendars) {
                    const workingHours = calendar.workingHours.filter(
                        (item) => item.photographerId == photographerId
                    );

                    if (workingHours.length) {
                        return workingHours;
                    }
                }
            };
            return address()[0].coordinates;
        };

        const eventAddresses = [];

        const directionsLink = `https://www.google.com/maps/dir/?api=1&origin=${photographerAddress()}&destination=${photographerAddress()}&travelmode=driving`;

        for (const calendar of this.state.calendars) {
            if (calendar.eventSources[0].events.length) {
                const photographerEvents = calendar.eventSources[0].events
                    .filter((event) => {
                        return (
                            event.userId == photographerId &&
                            (event.type == ICalendarItemType['scandphotos-booking'] ||
                                event.type == ICalendarItemType['se360-booking'])
                        );
                    })
                    .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());

                for (const event of photographerEvents) {
                    eventAddresses.push(event.coordinates);
                }
            }
        }

        eventAddresses.length &&
            window.open(directionsLink + '&waypoints=' + eventAddresses.join('|'), '_blank');
    };

    selectPhotographer = (photographerName: string) => {
        const photographer = this.props.photographers.find((x) => x.name === photographerName);
        this.photographerChange({ target: { value: photographer.id } });
    };

    WorkingHoursSwitchChanged = (toggle: boolean) => {
        this.setState({ calendars: [], loading: true }, () => {
            this.setState({ showSe360WorkingHours: toggle }, () => {
                let calendars = this.createCalendars(assign([], this.props.calendars));
                this.setState({ calendars: calendars, loading: false });
            });
        });
    };

    render() {
        const selectedPhotographer = parseInt(this.state.selectedPhotographer);
                
        const disableCommunicationButtons = this.state.selectedPhotographer < 1;
        const disableSendEmailToPhotographersButtons = this.state.selectedRegion < 1;

        const selectedPhotographerName = 
            selectedPhotographer && selectedPhotographer > -1
                ? this.props.photographers.find(photographer => photographer.id === selectedPhotographer).name
                : "";

        return (
            <Row>
                <Col sm={5} md={4} className="col-xlg-3">
                    {this.props.photographers && (
                        <FormGroup>
                            <ControlLabel>
                                {Translate('calendars/text/choose-photographer')}
                            </ControlLabel>
                            <div className="choose-photographer-container">
                                <div className="choose-photographer-select-container">
                                    <FormSelect
                                        defaultTranslateKey={'calendars/dropdown/choose-photographer'}
                                        id="dropdown-basic-default"
                                        data-testid="calendar-photographer-select"
                                        value={this.state.selectedPhotographer}
                                        onChange={(val) => {
                                            this.photographerChange(val);
                                        }}
                                    >
                                        {this.props.photographers.map((p, index: number) => (
                                            <option key={'photographer-' + index} value={p.id.toString()}>
                                                {p.name}
                                            </option>
                                        ))}
                                    </FormSelect>
                                </div>
                                <div className='communication-buttons-container'>
                                    <Button 
                                        className="communication-button"
                                        style={{ marginLeft: "12px" }} 
                                        disabled={disableCommunicationButtons}
                                        onClick={() => this.openPhotographerEmailModal(selectedPhotographerName)}
                                    >
                                        <MailIcon />
                                    </Button>
                                    <Button 
                                        className="communication-button"
                                        style={{ marginLeft: "4px" }} 
                                        disabled={disableCommunicationButtons}
                                        onClick={() => this.openPhotographerSmsModal(selectedPhotographerName)}
                                    >
                                        <SmsIcon />
                                    </Button>
                                </div>
                            </div>
                        </FormGroup>
                    )}
                    {this.props.regions && (
                        <FormGroup>
                            <ControlLabel>{Translate('calendars/text/choose-region')}</ControlLabel>
                            <div className="choose-photographer-container">
                                <div className="choose-photographer-select-container">
                                    <FormSelect
                                        defaultTranslateKey={'calendars/dropdown/choose-region'}
                                        id="dropdown-basic-default"
                                        data-testid="calendar-region-select"
                                        value={this.state.selectedRegion}
                                        onChange={(val) => {
                                            this.regionChange(val);
                                        }}
                                    >
                                        {this.props.regions.map((r, index: number) => (
                                            <option key={'region-' + index} value={r.id.toString()}>
                                                {r.name}
                                            </option>
                                        ))}
                                    </FormSelect>
                                </div>
                                <div className='communication-buttons-container'>
                                    <Button 
                                        className="communication-button"
                                        style={{ marginLeft: "12px" }} 
                                        disabled={disableSendEmailToPhotographersButtons}
                                        onClick={() => this.openSendEmailToPhotographersModal(Number(this.state.selectedRegion))}
                                    >
                                        <Tooltip title="Send an email to photographers in the selected region">
                                            <MailIcon />
                                        </Tooltip>
                                    </Button>
                                    <div
                                        className="communication-button"
                                        style={{ marginLeft: "4px", visibility: "hidden" }}
                                    />
                                </div>                                
                            </div>
                        </FormGroup>
                    )}
                    {this.state.selectedRegion > 0 && (
                        <div>
                            <DateTime
                                locale={moment.locale()}
                                input={false}
                                timeFormat={false}
                                onChange={this.onDateChange}
                                value={this.state.selectedDate}
                            />
                            <FormGroup>
                                <p style={{ marginTop: '10px' }}>
                                    {Translate('calendars/region/working-hours')}
                                </p>
                                {this.props.site !== getSiteName(Site.Zentuvo) ?
                                <p className="radio-switch button-row" style={{ margin: '0px' }}>
                                    <RadioInputSwitch
                                        name="workingHoursSwitch"
                                        id="se360"
                                        checked={this.state.showSe360WorkingHours}
                                        onChange={() => this.WorkingHoursSwitchChanged(true)}
                                        label={'SE360'}
                                    />
                                    <RadioInputSwitch
                                        name="workingHoursSwitch"
                                        id="scandphotos"
                                        checked={!this.state.showSe360WorkingHours}
                                        onChange={() => this.WorkingHoursSwitchChanged(false)}
                                        label={'Scandphotos'}
                                        wrapperClass="scandphotos-button-switch"
                                    />
                                </p> : null}
                            </FormGroup>
                        </div>
                    )}

                    {this.state.selectedPhotographer > 0 &&
                        this.state.selectedPhotographersSe360WorkingHours &&
                        this.state.selectedPhotographersScandphotosWorkingHours && (
                            <Panel>
                                <Panel.Body>
                                    <h4>{Translate('calendars/working-hours/title')}</h4>
                                    <br />
                                    <Tabs
                                        activeKey={this.state.selectedWorkingHoursSite}
                                        onSelect={(key) =>
                                            this.setState({
                                                selectedWorkingHoursSite: key
                                            })
                                        }
                                        id="working-hours-uncontrolled-tab"
                                    >
                                        {this.props.site === getSiteName(Site.Zentuvo) ?
                                            <Tab eventKey={1} title="Zentuvo">
                                                <WorkingHoursForm
                                                    workingHours={
                                                        this.state
                                                            .selectedPhotographersSe360WorkingHours
                                                    }
                                                    onChange={(workingHours: any[]) =>
                                                        this.onWorkingHoursChanged(workingHours, true)
                                                    }
                                                    user={this.props.user}
                                                />
                                            </Tab>
                                            :
                                            <>
                                                <Tab eventKey={1} title="SE360">
                                                    <WorkingHoursForm
                                                        workingHours={
                                                            this.state
                                                                .selectedPhotographersSe360WorkingHours
                                                        }
                                                        onChange={(workingHours: any[]) =>
                                                            this.onWorkingHoursChanged(workingHours, true)
                                                        }
                                                        user={this.props.user}
                                                    />
                                                </Tab>
                                                <Tab eventKey={2} title="Scandphotos">
                                                    <WorkingHoursForm
                                                        workingHours={
                                                            this.state
                                                                .selectedPhotographersScandphotosWorkingHours
                                                        }
                                                        onChange={(workingHours: any[]) =>
                                                            this.onWorkingHoursChanged(workingHours, false)
                                                        }
                                                    />
                                                </Tab>
                                            </>}
                                    </Tabs>
                                    <Button bsStyle="success" onClick={this.saveWorkingHours}>
                                        {Translate('calendars/button/update-working-hours')}
                                    </Button>
                                </Panel.Body>
                            </Panel>
                        )}
                </Col>
                <Col sm={7} md={8} className="col-xlg-9">
                    {this.state.calendars && this.state.calendars.length > 0 && (
                        <div>
                            {this.state.selectedPhotographer > 0 && (
                                <PhotographerCalendarComponent
                                    calendar={this.props.calendars[0]}
                                    onCreated={this.onCreated}
                                    onDeleted={this.onDeleted}
                                    onUpdated={this.onUpdated}
                                    onRangeChanged={(from: any, to: any) => {
                                        this.state.from = from;
                                        this.state.to = to;
                                        this.getCalendars();
                                    }}
                                    hideEditWorkingHours={true}
                                    photographerId={Number(this.state.selectedPhotographer)}
                                    showSe360WorkingHours={
                                        this.state.selectedWorkingHoursSite === 1 ? true : false
                                    }
                                    user={this.props.user}
                                />
                            )}
                            {this.state.selectedRegion > 0 &&
                                this.state.calendars.map((calendarSettings: any, index: number) => (
                                    <Calendar
                                        key={'calendar-' + index}
                                        settings={calendarSettings}
                                        calendarItems={null}
                                        workingHours={null}
                                        onChange={() => {}}
                                        onCreated={this.onCreated}
                                        onUpdated={this.onUpdated}
                                        onDeleted={this.onDeleted}
                                        canUnbook={false}
                                        onRangeChanged={(from: any, to: any) => {
                                            this.state.from = from;
                                            this.state.to = to;
                                            this.getCalendars();
                                        }}
                                        onDaynameClick={this.selectPhotographer}
                                        onSmsClick={this.openPhotographerSmsModal}
                                        onEmailClick={this.openPhotographerEmailModal}
                                        onDirectionsClick={this.showDirections}
                                        selectedDate={this.state.selectedDate}
                                        user={this.props.user}
                                    />
                                ))}
                        </div>
                    )}
                    {this.state.loading && (
                        <div style={{ height: '50vh' }}>
                            <Loader loaded={!this.state.loading}></Loader>
                        </div>
                    )}
                    {!this.state.loading &&
                        this.state.calendars &&
                        this.state.calendars.length === 0 && (
                            <h1>{Translate('calendars/text/choose-photographer-or-region')}</h1>
                        )}

                    {this.state.showSmsModal && this.state.smsRecipient && (
                        <SmsModal
                            onClose={() => {
                                this.setState({
                                    showSmsModal: false,
                                    smsRecipient: null
                                });
                            }}
                            recipient={this.state.smsRecipient}
                        />
                    )}
                    {this.state.showEmailModal && this.state.emailRecipient && (
                        <EmailModal
                            onClose={() => this.setState({ showEmailModal: false })}
                            recipient={this.state.emailRecipient}
                        />
                    )}
                </Col>
                <SendEmailToPhotographersModal
                    open={this.state.showSendEmailToPhotographersModal}
                    photographers={this.state.photographersInRegion}
                    onClose={this.closeSendEmailToPhotographersModal}
                />
            </Row>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        regions: state.photographerCalendars.regions,
        photographers: state.photographerCalendars.photographers,
        photographersByRegion: state.photographerCalendars.photographersByRegions,
        calendars: state.photographerCalendars.calendars,
        user: state.user,
        site: state.site
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getPhotographersByRegion: () => dispatch(Actions.getPhotographersByRegion()),
            getMultiplePhotographerCalendars: (ids: number[], from: any, to: any) =>
                dispatch(Actions.getMultiplePhotographerCalendars(ids, from, to)),
            createPhotographerCalendarItem: (item: any) =>
                dispatch(Actions.createPhotographerCalendarItem(item)),
            deletePhotographerCalendarItem: (item: any) =>
                dispatch(Actions.deletePhotographerCalendarItem(item)),
            updatePhotographerCalendarItem: (item: any) =>
                dispatch(Actions.updatePhotographerCalendarItem(item)),
            updatePhotographerCalendarWorkingHours: (
                photographerId: number,
                se360WorkingHours: any[],
                scandphotosWorkingHours: any[]
            ) =>
                dispatch(
                    Actions.updatePhotographerCalendarWorkingHours(
                        photographerId,
                        se360WorkingHours,
                        scandphotosWorkingHours
                    )
                )
        }
    };
}

function PhotographerCalendarPageWithFeatureToggle(props) {

    return (
        <PhotographerCalendarPage
            {...props}
        />
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PhotographerCalendarPageWithFeatureToggle);
